import React from 'react'

import Image from '@/UI/Image'

import StandardModal from './StandardModal'
import {
  StyledTextContentModalContainer,
  StyledTextContentModalWrapper,
  StyledTextContentModalImg,
  StyledTextContentModalContent
} from './styles'

const TextContentModal = ({
  isOpen,
  modalHandler,
  data
}) => {
  const {
    title,
    description,
    picture
  } = data

  return (
    <StandardModal
      wrapperId="textcontent-modal"
      isOpen={isOpen}
      setIsOpen={modalHandler}
      hideCloseButton
      wrapperProps={{
        css: {
          zIndex: 12,
          backdropFilter: 'blur(10px)',
        },
        exit: {
          opacity: 0,
          transition: { duration: 0.1 },
        },
      }}
      containerProps={{
        css: {
          with: '100%',
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
        initial: { y: '-100%' },
        animate: { y: '0%' },
        exit: {
          y: '-100%',
          transition: { delay: 0.6 },
        },
        transition: {
          type: 'spring',
          duration: 0.4,
          mass: 0.1,
        },
      }}
    >
      <StyledTextContentModalContainer>
        <button className="close-button" onClick={modalHandler}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
          >
            <path
              d="M23.5425 8.45753L8.45754 23.5425"
              stroke="#121212"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
            <path
              d="M8.45752 8.45753L23.5425 23.5425"
              stroke="#121212"
              strokeWidth="1.5"
              strokeLinecap="round"
            />
          </svg>
        </button>

        <StyledTextContentModalWrapper>
          <StyledTextContentModalImg>
            <Image {...picture} />
          </StyledTextContentModalImg>

          <StyledTextContentModalContent>
            <h3>{title}</h3>
            <div dangerouslySetInnerHTML={{ __html: description }} />
          </StyledTextContentModalContent>
        </StyledTextContentModalWrapper>
      </StyledTextContentModalContainer>
    </StandardModal>
  )
}

export default TextContentModal
